import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickActionComponent } from './pick-action/pick-action.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GlobalFilterComponent } from './global-filter/global-filter.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { CustomDtableComponent } from './custom-dtable/custom-dtable.component';
import { PipesModule } from '../pipes/pipes.module';
import { CamelcaseToSpacePipe } from '../pipes/camelcase-to-space.pipe';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { ChoiceFooterComponent } from './choice-footer/choice-footer.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { PickProfileComponent } from './pick-profile/pick-profile.component';

@NgModule({
  declarations: [
    PickActionComponent,
     GlobalFilterComponent,
     MenuItemComponent,
     CustomDtableComponent,
     ColorPickerComponent,
     ChoiceFooterComponent,
     DatePickerComponent,
     ChangePasswordComponent,
     FormErrorComponent,
     PickProfileComponent
    ],
  imports: [
    CommonModule,
    IonicModule,
    NgxDatatableModule,
    PipesModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    PickActionComponent,
    GlobalFilterComponent,
    MenuItemComponent,
    CustomDtableComponent,
    ColorPickerComponent,
    ChoiceFooterComponent,
    DatePickerComponent,
    ChangePasswordComponent,
    FormErrorComponent,
    PickProfileComponent
  ],
  providers: [CamelcaseToSpacePipe]
})
export class ComponentsModule { }
